import { IconBin } from "@synthesis/shared-icons";
import type { UserDto } from "@synthesis/shared-services/auth/user/types";
import { Button } from "@synthesis/shared-ui";

import { removeRoleWithUserFromProject } from "@synthesis/shared-services/project-gge/role/client";
import type { UserDataType } from "../list-of-experts-page.lib";

type FilledRoleItemProps = {
  userData: UserDataType;
  projectId: string;
  getRoleDisplay: (user: UserDto) => string;
  isArchived: boolean;
  isNotRight: boolean;
};

export const FilledRoleItem = ({ userData, projectId, getRoleDisplay, isArchived, isNotRight }: FilledRoleItemProps) => {
  const handleDelete = async () => {
    if (!userData.projectRole?.id || !userData.user.id) return;
    await removeRoleWithUserFromProject({ path: { roleId: userData.projectRole.id, projectId, userId: userData.user.id } });
    window.location.reload();
  };

  return (
    <div className="not-last:border-b grid grid-cols-[1fr_1.5fr_1fr_1fr]">
      <div className="flex grow items-center justify-start px-4 py-6">{userData.groups[0]?.name || ""}</div>
      {userData.user?.firstName ? (
        <div className="flex grow items-center justify-start px-4 py-6">
          {userData.user?.lastName} {userData.user?.firstName} {userData.user?.middleName}
        </div>
      ) : (
        <div className="flex grow items-center justify-start px-4 py-6">Пользователь не найден (удален, id &quot;{userData.user?.id}&quot;)</div>
      )}
      <div className="flex grow items-center justify-start px-4 py-6">{userData.user?.firstName ? getRoleDisplay(userData.user) : ""}</div>
      <div className="flex grow items-center justify-start px-4 py-6">
        <Button disabled={isArchived || isNotRight} size="sm" leftIcon={<IconBin className="size-5" />} onClick={handleDelete}>
          Исключить
        </Button>
      </div>
    </div>
  );
};
